import { render } from "./NotificationsModal.vue?vue&type=template&id=b861b13c&scoped=true&ts=true"
import script from "./NotificationsModal.vue?vue&type=script&lang=ts"
export * from "./NotificationsModal.vue?vue&type=script&lang=ts"

import "./NotificationsModal.vue?vue&type=style&index=0&id=b861b13c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b861b13c"]])

export default __exports__